import {Injectable} from '@angular/core';

export type MobileBackHandler = () => boolean | Promise<boolean>;

@Injectable({providedIn: 'root'})
export class MobileBackCoordinatorService {
  private readonly handlers: Array<{id: string; handler: MobileBackHandler}> = [];
  private handling = false;

  public register(id: string, handler: MobileBackHandler): () => void {
    this.remove(id);
    this.handlers.push({id, handler});
    return () => this.remove(id);
  }

  public get handlerCount(): number {
    return this.handlers.length;
  }

  public async handle(): Promise<boolean> {
    if (this.handling) {
      return true;
    }
    this.handling = true;
    try {
      for (const entry of [...this.handlers].reverse()) {
        if (await entry.handler()) {
          return true;
        }
      }
      return false;
    } finally {
      this.handling = false;
    }
  }

  private remove(id: string): void {
    const index = this.handlers.findIndex((entry) => entry.id === id);
    if (index >= 0) {
      this.handlers.splice(index, 1);
    }
  }
}
